export const formatText = (value: string, pattern: string): string => {
  if (!value) {
    return '';
  }

  let i = 0;

  return pattern.replace(/#/g, _ => value[i++]);
};

export const capitalize = (phrase: string): string => {
  if (!!phrase) {
    return phrase
      .trim()
      .split(' ')
      .map(text => text[0].toUpperCase() + text.slice(1).toLowerCase())
      .join(' ');
  }
};

export const replaceText = (textItem: string, pattern: string, value: string) => {
  return textItem.replace(pattern, value);
};

export const capitalizeAndRemoveUnderscores = (text: string): string => {
  return capitalize(text).replace(/_+/g, ' ');
};
